import { render, staticRenderFns } from "./AvgStudentClass.vue?vue&type=template&id=3c75683a&"
import script from "./AvgStudentClass.vue?vue&type=script&lang=js&"
export * from "./AvgStudentClass.vue?vue&type=script&lang=js&"
import style0 from "./AvgStudentClass.vue?vue&type=style&index=0&id=3c75683a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports